import { CircularProgress } from "@mui/material";
import React from "react";

function Loader() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={20} sx={{ color: "#11C89B" }} />
    </div>
  );
}

export default Loader;
